<template>
  <div class="">
    <m-content-wrapper content-type="page" :content-category="contentCategory">
      <template v-slot="{contents}">
        <div :class="itemClass" v-for="(content,index) in contents" :key="content.id">
          <m-a :href="findLinkOnContent(content.abstraction)">
            <img :alt="content.title" :src="content.thumbnail"
                 class="rounded w-100 my-1"/>
          </m-a>
        </div>
      </template>
    </m-content-wrapper>
  </div>
</template>

<script>
import {ContentArchiveProps} from './ContentArchiveProps'
import mContentWrapper from "../../Wrappers/ContentWrapper";

import mA from '../../Tags/A'

export default {
  name: "ContentArchive2",
  props: {
    ...ContentArchiveProps,
    itemClass: {
      default: 'col-lg-6'
    }
  },
  components: {mA, mContentWrapper,}
}
</script>

<style scoped>

</style>